import {Component, Input} from '@angular/core';
import {NavController, NavParams} from "ionic-angular";

/**
 * Generated class for the StaffCompletedBookingsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'staff-completed-bookings',
    templateUrl: 'staff-completed-bookings.html'
})
export class StaffCompletedBookingsComponent {
    @Input() barber: any;
    @Input() currencySymbol: any;

    constructor(public navCtrl: NavController, public  navParams: NavParams) {

    }
}



// WEBPACK FOOTER //
// ./src/components/staff-completed-bookings/staff-completed-bookings.ts